// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { IndicatorsManagerItem } from '../../cache/ObjectManager/IndicatorsManagerItem';
import { PanelNames } from '../../UtilsClasses/FactoryConstants';
import { ObjectManagerPanelBase } from './ObjectManagerPanelBase';
import { TerceraChartIndicatorStorageRenderer } from '@front/chart/Renderers/Indicators/TerceraChartIndicatorStorageRenderer';
import { TerceraChartActionEnum } from '@front/chart/TerceraChartAction';
export class IndicatorsManagerPanel extends ObjectManagerPanelBase {
    constructor() {
        super();
        this.ChartActionVisibility = TerceraChartActionEnum.PlateIndicatorVisible;
        this.ChartActionSettings = TerceraChartActionEnum.PlateIndicatorSettings;
        this.ChartActionRemove = TerceraChartActionEnum.PlateIndicatorRemove;
        this.ChartActionDeleteAll = TerceraChartActionEnum.Indicator;
        this.Name = 'IndicatorsManagerPanel';
        this.headerLocaleKey = 'chart.indicators';
    }
    getType() {
        return PanelNames.IndicatorsManagerPanel;
    }
    subscribe() {
        if (!isNullOrUndefined(this.Chart)) {
            this.Chart.OnAddIndicator.Subscribe(this.AddItemToTable, this);
            this.Chart.OnRemoveIndicator.Subscribe(this.RemoveItemFromTable, this);
        }
    }
    unsubscribe() {
        if (!isNullOrUndefined(this.Chart)) {
            this.Chart.OnAddIndicator.UnSubscribe(this.AddItemToTable, this);
            this.Chart.OnRemoveIndicator.UnSubscribe(this.RemoveItemFromTable, this);
        }
    }
    AddItemToTable(renderer) {
        const quickTable = this.getQuickTable();
        if (isNullOrUndefined(quickTable)) {
            return;
        }
        quickTable.AddItem(new IndicatorsManagerItem(renderer));
    }
    populateItemsDirect() {
        super.populateItemsDirect();
        if (isNullOrUndefined(this.Chart)) {
            return;
        }
        for (const window of this.Chart.windowsContainer.Windows) {
            const renderer = window.GetRenderer(TerceraChartIndicatorStorageRenderer);
            this.populateItems(renderer.Indicators);
        }
    }
    populateItems(renderers) {
        for (const renderer of renderers) {
            this.AddItemToTable(renderer);
        }
    }
}
